import request from '@/config/axios'

export const getSetting = () => request.get({ url: '/rental/setting/get' })
export const updateSetting = (data: any) => request.put({ url: '/rental/setting/update', data })
